<!-- Section Loader (Add "position-relative" class to wrapper div of section) -->
<div id="pageLoader" class="pmd-loader" [ngClass]="showLoader == false ? 'd-none' : '' " aria-label="Data is loading...">
    <div class="loader">
        <img src="assets/images/kanz-icon.png" class="fils-loader">
        <svg class="circular" viewBox="25 25 50 50" aria-hidden="true">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"
                aria-hidden="true" />
        </svg>
    </div>
</div>
